import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import HeroImage from "@assets/images/onboarding/gradient-light-transparent.png";
import ListPreview from "@assets/images/onboarding/list-preview.png";

import { OnboardingExit } from "./OnboardingExit";

export const OnboardingLayout = () => {
	return (
		/*
		 * This element is the scroll container for every onboarding screen (PREC-3976): it is
		 * bounded by the viewport and scrolls, rather than growing past the window and relying on
		 * the document to absorb the overflow. `html`/`body` are both capped at 100vh in
		 * index.css, so anything that stops the document from scrolling — a modal's scroll lock,
		 * say — would otherwise leave a too-tall page with no way to reach its ends.
		 */
		<div className="flex h-dvh w-full flex-col overflow-y-auto" id="portal-auth">
			<Box
				alt="Background image"
				component="img"
				src={ListPreview}
				sx={{
					width: "100%",
					height: "100%",
					position: "fixed",
					objectFit: "cover",
					inset: 0,
					zIndex: -1,
				}}
			/>
			<Box
				alt="Background image"
				component="img"
				src={HeroImage}
				sx={{
					width: "100%",
					height: "100%",
					position: "fixed",
					objectFit: "cover",
					inset: 0,
					zIndex: -1,
				}}
			/>

			<OnboardingExit />

			{/*
			 * Vertical centring belongs on the page wrapper as `my-auto`, never as `justify-center`
			 * on the scroller above: auto margins collapse to 0 once the content outgrows the
			 * container, while `justify-content: center` pushes the top half into an area no
			 * scrolling reaches. The padding stays at every width so a page taller than the window
			 * never sits flush against its edges.
			 */}
			<div className="flex w-full flex-col py-8 xl:items-center 2xl:my-auto">
				<Outlet />
			</div>
		</div>
	);
};
